import { cn } from '@vidahealth/vida-ui';
import { ActivityIndicator, View } from 'react-native';

export function LoadingScreen({ className }: { className?: string }) {
  return (
    <View
      className={cn(
        'flex-1 items-center justify-center bg-background-0 dark:bg-neutral-950',
        className
      )}
    >
      <ActivityIndicator size='large' />
    </View>
  );
}
